import { useState, useContext, useEffect } from "react";
import {
  Grid,
  Paper,
  Typography,
  List,
  ListItem,
  ListItemButton,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import { EventContext } from "../../../contexts/EventContext";

import Contract from "./Contract";
import Uninvoiced from "./Uninvoiced";

const Licensing = ({ org }) => {
  const navigate = useNavigate();
  const { userData } = useContext(EventContext);
  const [contractOpen, setContractOpen] = useState(false);
  const [uninvoicedOpen, setUninvoicedOpen] = useState(false);

  return (
    <Paper elevation={3} style={{ width: "100%", height: 300, padding: 10 }}>
      <Grid container direction="column" style={{ height: "100%" }}>
        <Grid item>
          <Typography variant="h5">Licensing</Typography>
        </Grid>
        <Grid item>
          {org ? (
            <List>
              {userData?.permissions?.canViewContract ||
              userData?.role === "superadmin" ? (
                <ListItem>
                  <ListItemButton onClick={() => setContractOpen(true)}>
                    Contract
                  </ListItemButton>
                </ListItem>
              ) : null}
              {userData?.permissions?.canViewInvoicing ||
              userData?.role === "superadmin" ? (
                <ListItem>
                  <ListItemButton
                    onClick={() =>
                      navigate(`/invoices/${org._id}`, { state: { org } })
                    }
                  >
                    Invoices
                  </ListItemButton>
                </ListItem>
              ) : null}
              {userData?.permissions?.canViewPayouts ||
              userData?.role === "superadmin" ? (
                <ListItem>
                  <ListItemButton
                    onClick={() =>
                      navigate(`/payouts/${org._id}`)
                    }
                  >
                    Payouts
                  </ListItemButton>
                </ListItem>
              ) : null}
            </List>
          ) : null}
        </Grid>
        {userData?.role === "superadmin" ? (
          <Grid
            item
            style={{ marginTop: "auto", padding: 12, cursor: "pointer" }}
            onClick={() => setUninvoicedOpen(true)}
          >
            <Typography align="center">Uninvoiced Events</Typography>
          </Grid>
        ) : null}
      </Grid>
      <Contract
        open={contractOpen}
        close={() => setContractOpen(false)}
        org={org}
      />
      <Uninvoiced
        open={uninvoicedOpen}
        close={() => setUninvoicedOpen(false)}
      />
    </Paper>
  );
};

export default Licensing;
